// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2axuQB85WQXRRQ_W8rSRvP{margin-bottom:3.6rem}.ruBOHfd3Xi4D_gfMOyv7y{margin-bottom:1.6rem}._3XCd5NXPSnfjaWOXpdD7gK{width:100%;height:25rem;display:block;margin:3.5rem auto}@media only screen and (min-width:992px){._3XCd5NXPSnfjaWOXpdD7gK{width:42rem;height:31rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "_2axuQB85WQXRRQ_W8rSRvP",
	"code": "ruBOHfd3Xi4D_gfMOyv7y",
	"video": "_3XCd5NXPSnfjaWOXpdD7gK"
};
module.exports = ___CSS_LOADER_EXPORT___;
